import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import APP from '../config'

import usersStore from './users'
import interest from './interest'
import plans from './plans'
import unauthpage from './unauthpage'
import charities from './charities'
import authpage from './authpage'
import experts from './experts'
import videoPlayer from './videoplayer'
import search from './search'
import contactus from './contactus'
import events from './events'
import gifts from './gifts'
import configration from './configuration'
import dynamiccontents from './dynamiccontents'
import { dateHelpers } from '../helpers/dateHelpers.js'

Vue.use(Vuex)
require('es6-promise').polyfill()
// console.info(APP)

// Set baseURL for APIs
axios.defaults.baseURL = 'https://api1.tonenetworks.com/v1/'

axios.defaults.validateStatus = function (status) {
    return status < 500 // Reject only if the status code is greater than or equal to 500
}
// Load Authorization header if user were logedin
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // Do something before request is sent
    let userId = 0
    let token = ''
    let loggedUser = localStorage.getItem('loggedUser')
    let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected (temporary) after interests are set
    if (loggedUserTemp) {
        loggedUserTemp = JSON.parse(loggedUserTemp)
        userId = loggedUserTemp.userId
        token = `${localStorage.getItem('token')}`
    }
    if (loggedUser) {
        loggedUser = JSON.parse(loggedUser)
        userId = loggedUser.userId
        token = `${localStorage.getItem('token')}`
    }
    if (token === undefined || token === '') {
        token = null
    }
    let serverDate = dateHelpers.returnFormattedUTCDateTime()
    // console.log('returned server date', serverDate)
    config.headers.common['Authorization'] = token
    config.headers.common['RequestDateTime'] = serverDate
    config.headers.common['UserID'] = userId
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})
export default new Vuex.Store({
    state: {
        scrolled: false
    },
    getters: {
        isScrolled (state) {
            return state.scrolled
        }
    },
    mutations: {
        setStickyNavigation (state, obj) {
            state.scrolled = obj.value
        }
    },
    modules: {
        usersStore,
        interest,
        plans,
        unauthpage,
        charities,
        authpage,
        experts,
        videoPlayer,
        search,
        contactus,
        events,
        gifts,
        configration,
        dynamiccontents
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js